/* ============================================================
   MagicBeez — UI flottante (CTA collant + WhatsApp)
   Fail-safe : le CTA est visible par défaut (CSS). Le JS ne fait
   que le MASQUER en haut de page et près du footer. Si le JS
   échoue, le CTA reste donc visible et fonctionnel.
   ============================================================ */
(function () {
  if (window.__mbUiInit) return;
  window.__mbUiInit = true;

  var cta = document.querySelector('[data-mb-sticky-cta]');
  var wa = document.querySelector('[data-mb-wa]');

  // Révéler les éléments (retirer l'attribut hidden initial)
  if (cta) cta.hidden = false;
  if (wa) {
    wa.hidden = false;
    if (cta) cta.classList.add('mb-has-wa');
  }

  if (!cta && !wa) return;

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight || 0;
    var docH = document.documentElement.scrollHeight || 0;

    if (cta) {
      var atTop = y < vh * 0.55;                       // encore dans le hero
      var nearFooter = (y + vh) > (docH - 140);        // tout en bas
      if (atTop || nearFooter) cta.classList.add('mb-cta-hidden');
      else cta.classList.remove('mb-cta-hidden');
    }

    if (wa && cta && isMobile()) {
      // Quand la barre CTA est visible en bas, le WhatsApp remonte au-dessus
      if (cta.classList.contains('mb-cta-hidden')) wa.classList.remove('mb-wa--above-bar');
      else wa.classList.add('mb-wa--above-bar');
    } else if (wa) {
      wa.classList.remove('mb-wa--above-bar');
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { update(); ticking = false; });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
